import React, { useEffect, useRef, useCallback } from "react";
import Footer from '../Footer';
import './Tim.css';

const EMPLOYEES = [
  {
    id: 1,
    name: "Dr. sc. Vladimir Pezo dr. med. vet.",
    specialty: "Specijalist za bolesti pasa i mačaka",
    image: "./images/tim1.jpg",
    description: `Dr. sc. Vladimir Pezo, DMV, diplomirao je na zagrebačkom Veterinarskom fakultetu, a nakon toga započinje sad već dugogodišnji rad u veterinarskoj praksi.

Davnih osamdesetih upisuje poslijediplomski studij - specijalizaciju iz bolesti i uzgoja domaćih mesojeda te stječe status specijalista za bolesti i uzgoj pasa i mačaka.

Godine 1985. nakon trogodišnjeg istraživanja, na klinici za kirurgiju i oftalmologiju Veterinarskog fakulteta brani doktorsku disertaciju te stječe znanstveni stupanj doktora medicinskih znanosti iz područja veterine.

Već od samih početaka radnog vijeka promovira ideju i organizira ambulantu specijaliziranu za malu praksu. Razvijajući malu praksu, uvodeći nove metode u dijagnostici i terapiji, trajno se educira. Dodatno se usavršavao na Veterinarskoj klinici za male životinje u Dietikonu (Švicarska) te na klinici za male životinje u Grazu (Austrija). Napisao je i objavio četiri knjige: "Priče iz veterinarske ambulante", "Tko je pas", "Tko je mačka" i "Nove priče iz veterinarske ambulante". Nastupao je u brojnim televizijskim emisijama koje su se bavile tematikom kućnih ljubimaca, a već 39 godina na Radio Sljemenu uređuje autorsku emisiju "Kućni ljubimci". Govori njemački jezik. Hobi mu je lijepa književnost, filozofija i psihologija.`
  },
  {
    id: 2,
    name: "Univ. Mag. Sanja Vučinić dr. med. vet.",
    specialty: "Specijalist za bolesti pasa i mačaka",
    image: "./images/tim2.jpg",
    description: `Univ. mag. Sanja Vučinić, DMV, diplomirala je na Veterinarskom fakultetu u Zagrebu i odmah nakon stjecanja diplome počinje raditi u specijalističkoj veterinarskoj praksi za male životinje "Dr. Pezo".

Kao velika ljubiteljica i vlasnica kućnih ljubimaca, od početka svoje veterinarske karijere ulaže svekoliki trud i znanje da bi svojim malim pacijentima pružila što bolju skrb.

Nakon pet godina stjecanja iskustva i znanja, upisuje poslijediplomski studij - specijalizaciju iz bolesti i uzgoja domaćih mesojeda, nakon čega stječe titulu sveučilišne magistrice i status specijalistice za bolesti i uzgoj pasa i mačaka.

Dodatno se educirala na stručnim skupovima u zemlji i inozemstvu. Nakon 28 godina radnog iskustva u maloj praksi poseban interes i iznimnu stručnost pokazuje u kirurgiji, napose abdominalnoj te prema unutrašnjim bolestima.

Uz ovaj bogati životopis 2023. godine polaže i državni stručni ispit s čime stječe titulu ovlaštenog veterinara kao i zasluženu titulu voditeljice ambulante.`
  },
  {
    id: 3,
    name: "Jelena Hlušička dr. med. vet.",
    specialty: "",
    image: "./images/tim3.jpg",
    description: `2014. sudjeluje u pisanju znanstvenog rada "Kemijska ocjena kakvoće mlijeka podrijetlom od ovaca hranjenih dodatkom pripravka plemenite pečurke Agaricus bisporus".

2016. napisala sa kolegicom znanstveni rad "Sastav i svojstva magarećeg mlijeka" sa kojim su sudjelovale u natječaju za rektorovu nagradu.

2017. diplomirala na Veterinarskom fakultetu u Zagrebu s temom "Higijena, držanje i dobrobit kunića". Nakon stjecanja diplome počinje raditi u specijalističkoj veterinarskoj praksi za male životinje Dr. Pezo.

2018. godine pohađa i polaže program iz područja rendgenologije i ultrazvučne dijagnostike na Veterinarskom fakultetu.

2019. je pohađala radionicu osnove ehokardiografije na veterinarskom fakultetu pod vodstvom prof. Marin Torti i dr. Jović na veterinarskom fakultetu u Zagrebu.

2021 - 2022. završava školu akupunkture na HUPED-u.

Travanj 2024. pohađa tečaj napredne ehokardiografije pod vodstvom prof. Marin Torti i dr. Jović koji se održao u Samoboru.

Rujan 2024. - upisuje specijalistički studij "Kirurgija, anesteziologija, oftalmologija i veterinarska stomatologija" na veterinarskom fakultetu u Zagrebu.

Sudjelovala je i u drugim stručnim i znanstvenim radionicama i skupovima. Svoj poziv obavlja stručno, profesionalno i sa puno ljubavi.`
  },
  {
    id: 4,
    name: "Dr. sc. Tajna Kovač dr. med. vet.",
    specialty: "",
    image: "./images/tim4.jpg",
    description: `Tajna Kovač rođena je u Zagrebu, gdje je završila Gimnaziju Tituša Brezovačkog. Godine 2008. upisuje Veterinarski fakultet Sveučilišta u Zagrebu, smjer Kućni ljubimci. Tijekom svih šest godina studija aktivno je volontirala u Veterinarskoj ambulanti za male životinje "Buba" u Zagrebu, gdje je stekla bogato praktično iskustvo u radu s kućnim ljubimcima.

Diplomirala je 2014. godine s temom "Dijagnostika i liječenje bolesti usne šupljine u kunića", koju je usmeno prezentirala na 6. Međunarodnom kongresu "Veterinarska znanost i struka" 2015. godine. Odmah nakon diplome dobila je ponudu za posao u Veterinarskoj ambulanti Šegota, gdje je radila do ožujka 2022. godine.

Od početka karijere pokazuje poseban interes za dijagnostiku i liječenje bolesti malih sisavaca (kunića, glodavaca i pitomih vretica), kao i za unutarnje bolesti, anesteziologiju te oftalmologiju pasa i mačaka. U travnju 2022. godine pridružuje se Veterinarskoj stručnoj praksi Dr. Pezo gdje nastavlja s profesionalnim razvojem i edukacijom.

Sudjelovala je na brojnim stručnim i znanstvenim skupovima, konferencijama i radionicama te objavljuje stručne i znanstvene članke. Od edukacija posebno ističe dermatološke radionice i radionice ultrazvučne dijagnostike abdomena, koje su doprinijele daljnjem razvoju njezina kliničkog znanja.

Tijekom doktorskog studija, pod mentorstvom prof. Nikše Leme, dodatno se usavršavala u području dermatologije, alergologije i oftalmologije, a 2025. godine stječe akademski stupanj doktora znanosti obranom disertacije pod naslovom: "Učinak sistemske terapije kortikosteroidima, ciklosporinom i oklacitinibom na kliničke i citološke značajke očne spojnice u pasa s atopijskim dermatitisom."`
  },
  {
    id: 5,
    name: "Ana Marčetić dr. med. vet.",
    specialty: "",
    image: "./images/tim6.jpg",
    description: `Veterinom se bavi od 2011 godine.

Diplomirala na Veterinarskom fakultetu Sveučilišta u Zagrebu, nakon čega kontinuirano radi u kliničkoj praksi.

Posebna područja profesionalnog interesa je interna medicina malih životinja s osvrtom na dermatologiju.

U svakodnevnom radu fokusirana na temeljitu dijagnostiku, individualni pristup svakom pacijentu te na dugoročnu brigu o zdravlju kućnih ljubimaca.

Svoje znanje redovito nadograđuje na domaćim i međunarodnim veterinarskim kongresima, edukacijama i stručnim skupovima kako bi klijentima osigurala suvremene i provjerene dijagnostičke i terapijske pristupe.`
  },
  {
    id: 6,
    name: "Nevenka Kaloper dr. med. vet.",
    specialty: "",
    image: "./images/tim5.jpg",
    description: `Nevenka Kaloper, rođena je u Šibeniku, gdje je završila gimnaziju Antuna Vrančića.

Godine 2016. upisuje Veterinarski fakultet Sveučilišta u Zagrebu, a diplomirala je 2022. s temom "Klinička primjena nesteroidnih protuupalnih lijekova u mačaka" te odmah nakon stjecanja diplome počinje raditi u Specijalističkoj veterinarskoj praksi za male životinje dr. Pezo.

Sudjelovala je na raznim edukativnim radionicama u svrhu stručnog usavršavanja. Poseban interes ima prema unutarnjim bolestima i ultrazvučnoj dijagnostici.`
  },
  {
    id: 7,
    name: "Marija Ladović",
    specialty: "Veterinarska tehničarka",
    image: "./images/tim8.jpg",
    description: `Marija Ladović završila je srednju veterinarsku školu 2018. godine u Zagrebu te stekla zvanje veterinarskog tehničara. Tijekom školovanja obavljala je stručnu praksu u veterinarskoj ambulanti gdje je stekla vrijedno praktično iskustvo u radu s malim životinjama te upoznala svakodnevne organizacijske i stručne zadatke veterinarske struke, a njezinoj ljubavi prema struci doprinosi i to da je cijeli život odrasla okružena i velikim i malim životinjama.

Za vrijeme prakse pokazala je visoku razinu marljivosti, odgovornosti i interesa za struku. Sudjelovala je u pripremi životinja za dijagnostičke postupke i operativne zahvate, asistirala veterinarima tijekom pregleda i zahvata te vodila brigu o higijeni prostora, instrumenata i opreme.

Ljubiteljica je životinja te s posebnom pažnjom i strpljenjem pristupa svakom pacijentu. Svojim smirenim i ljubaznim ponašanjem doprinosi osjećaju sigurnosti kod životinja, ali i njihovih vlasnika, pomažući im da lakše i mirnije prođu kroz dijagnostičke i terapijske postupke.

Slobodno vrijeme najradije provodi u šetnjama sa psom, boraveći u prirodi te družeći se s obitelji.`
  },
  {
    id: 8,
    name: "Ana Blažević",
    specialty: "Veterinarska tehničarka",
    image: "./images/tim7.jpg",
    description: `Ana Blažević završila je srednju Veterinarsku školu u Zagrebu te radi kao veterinarska tehničarka. U svakodnevnom radu ističe se odgovornošću, strpljenjem i brižnim pristupom prema životinjama. Svojim smirenim ponašanjem doprinosi ugodnoj atmosferi za vlasnike i njihove ljubimce. U slobodno vrijeme uživa u folkloru i druženju sa svojim psom Nikom.`
  }
];

export default function Tim() {
  const employeeRefs = useRef([]);

  const formatDescription = useCallback((text) => {
    return text.split('\n\n')
      .filter(paragraph => paragraph.trim() !== '')
      .map((paragraph, index) => (
        <p key={index}>{paragraph.trim()}</p>
      ));
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { 
        threshold: 0.2,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const cards = document.querySelectorAll('.employee-card-full');
    cards.forEach(card => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="tim-container">
        <header className="tim-header">
          <h1 className="tim-title">Naš Tim</h1>
        </header>

        <div className="employees-list">
          {EMPLOYEES.map((employee, index) => (
            <article 
              key={employee.id} 
              className={`employee-card-full ${index % 2 === 1 ? 'reverse' : ''}`}
              ref={el => employeeRefs.current[index] = el}
            >
              <img 
                src={employee.image} 
                alt={employee.name} 
                className="employee-image-full"
                loading="lazy"
              />
              
              <div className="employee-content">
                <div className="employee-header">
                  <h2 className="employee-name-full">{employee.name}</h2>
                </div>

                {employee.specialty && (
                  <p className="employee-specialty">{employee.specialty}</p>
                )}

                <div className="employee-description">
                  {formatDescription(employee.description)}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}